import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { resetMap } from "../../slices/map";
export const useResetMap = () => {
    const dispatch = useDispatch();
    return useCallback(() => {
        dispatch(resetMap());
    }, [dispatch]);
};
